import { Formik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';
import { useTranslation } from '../../lib/i18n';
import { trackEvent } from '../../lib/tracking';
import { Button } from '../common/button';
import { NumberInput } from './fields';

const WineCalculatorForm = ({ className = '' }) => {
  const { t } = useTranslation();
  const [result, setResult] = useState(undefined);

  const reset = () => {
    setResult(undefined);
  };

  return (
    <div className={`mx-auto max-w-md ${className}`}>
      {result ? (
        <div>
          {t('winecalculatorresult')}
          <div className='h3 mt-3'>
            {result} {result === 1 ? t('bottle') : t('bottles')}
          </div>

          <Button onClick={reset} className='mt-8' filled={false}>
            {t('recalculate')}
          </Button>
        </div>
      ) : (
        <Formik
          initialValues={{
            nbrGuests: 2,
            nbrGlasses: 2,
            duration: 1,
          }}
          validationSchema={Yup.object({
            nbrGuests: Yup.number().required(t('required')).min(1),
            nbrGlasses: Yup.number().required(t('required')).min(1),
            duration: Yup.number().required(t('required')).min(1),
          })}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            // round to number to nearest 0.5
            // https://stackoverflow.com/questions/6137986/javascript-roundoff-number-to-nearest-0-5
            const calc = Math.max(
              Math.round(
                (2 * (values.nbrGuests * values.nbrGlasses * values.duration)) /
                  8,
              ) / 2,
              0.5,
            );
            trackEvent({
              category: 'form',
              action: 'submit',
              label: 'wine calculator',
              value: calc,
            });
            setResult(calc);
            resetForm({});
            setSubmitting(false);
          }}
        >
          {({ handleSubmit, isSubmitting, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <NumberInput
                className='mx-auto'
                label={t('nbrguests')}
                type='number'
                name='nbrGuests'
                minValue={1}
                onValueChange={(v) => setFieldValue('nbrGuests', v)}
              />

              <NumberInput
                className='mx-auto mt-5'
                label={t('nbrglasses')}
                type='number'
                name='nbrGlasses'
                minValue={1}
                onValueChange={(v) => setFieldValue('nbrGlasses', v)}
              />

              <NumberInput
                className='mx-auto mt-5'
                label={t('partyduration')}
                type='number'
                name='duration'
                minValue={1}
                onValueChange={(v) => setFieldValue('duration', v)}
              />

              <Button
                filled
                loading={isSubmitting}
                type='submit'
                className='mt-8'
              >
                {t('calculate')}
              </Button>
            </form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default WineCalculatorForm;
